//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IUrlRouterProvider } from 'angular-ui-router';
import { hasFeature } from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  if (hasFeature('galleries')) {
    urlRouterProvider.when('/fanreel', '/galleries/website');
    urlRouterProvider.when('/fanreel/summary', '/galleries/website');
    urlRouterProvider.when('/fanreel/moderation/{reelId}', '/galleries/website');
    urlRouterProvider.when('/fanreel/management/{reelId}', '/galleries/website');
  } else if (hasFeature('instashop')) {
    urlRouterProvider.when('/fanreel', '/galleries/instashop');
    urlRouterProvider.when('/fanreel/summary', '/galleries/instashop');
    urlRouterProvider.when('/fanreel/management/{reelId}', '/galleries/instashop');
    urlRouterProvider.when('/fanreel/moderation/{reelId}', '/galleries/instashop');
  }
}
